var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class SonyVplProjector {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: `power_status ?`,
                next: /standby|startup|on|cooling|off/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        this.powerOnValues = ['on', 'startup'];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.displayBlank = {
            // no get blank query
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`blank ?`, /("on"|"off"|err)/i, tags);
                return match[1] === '"on"';
            }),
            set: (blank, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`blank ${blank ? '"on"' : '"off"'}`, /ok/i, tags);
                if (match[1] === undefined)
                    return this.state.displayBlank.value;
                return blank;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.displayFreeze = {
            // no get freeze query
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`freeze ?`, /("on"|"off"|err)/i, tags);
                return match[1] === '"on"';
            }),
            set: (freeze, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`freeze ${freeze ? '"on"' : '"off"'}`, /ok/i, tags);
                if (match[1] === undefined)
                    return this.state.displayFreeze.value;
                return freeze;
            }),
            powerOffRestrictions: ['set'],
        };
        // Firmware version has the format:
        // [{"main":"1.10.0a"}, {"main_data":"01/01.01"}, {"sub":"1.01.0a"}, {"ext":"1.03.0a")]
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.firmwareVersion.value;
            }),
            hasControl: () => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`version ?`, /"main":"([\d\.a-z]+)"}/i, [
                    'get.firmwareVersion',
                ]);
                if (match[1] !== undefined) {
                    this.state.firmwareVersion.update(match[1]);
                    return true;
                }
                return false;
            }),
            powerOffRestrictions: ['get'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`power_status ?`, /(standby|startup|on|cooling\d|saving_cooling\d|saving_standby)/i, tags);
                if (match[1]) {
                    return this.powerOnValues.includes(match[1]);
                }
                else
                    return this.state.power.value;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`power ${power ? '"on"' : '"off"'}`, /(ok|err)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 20000 : 60000);
                if (match[1] !== undefined && match[1] === 'ok') {
                    this.framework.suspend(power ? 20000 : 60000);
                }
                return power;
            }),
        };
        this.serialNumber = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`serialnum ?`, /(.+)/i, tags);
                return match[1] ? match[1] : 'unknown';
            }),
            powerOffRestrictions: ['get'],
        };
        this.videoInput = {
            // no get API command
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`input ?`, /err|(.+)/i, tags);
                if (match[1] === undefined)
                    return this.state.videoInput.value;
                return match[1];
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`input "${code}"`, /ok/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 1000);
                if (match[1] === undefined)
                    return this.state.videoInput.value;
                return code;
            }),
            powerOffRestrictions: ['set'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                controls: ['power'],
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
SonyVplProjector.driverType = 'socketDriver';
SonyVplProjector.key = '-Need one';
SonyVplProjector.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
SonyVplProjector.socketOptions = (config) => [
    Object.assign(Object.assign({}, SonyVplProjector.baseSocketOptions), { port: 53595 }),
    Object.assign(Object.assign({}, SonyVplProjector.baseSocketOptions), { port: 4999 }),
];
